import baseUrl from '../../../utils/baseUrl';
import getToken from '../../../utils/getToken';

export default async function addDMChatRoom({ sourceUserProfileId, targetUserProfileId }) {
  return fetch(`${baseUrl()}/api/v1/chat_rooms`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${getToken()}`
    },
    body: JSON.stringify({
      chat_room: {
        source_user_profile_id: sourceUserProfileId,
        target_user_profile_id: targetUserProfileId
      }
    })
  });
}
